import React, { useEffect, useRef } from 'react';
import { Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import tPaths from '../../../../../utils/tPaths';

interface IFilterItemListProps {
  styles: Record<string, any>;
  jsxListItems: any[];
  isAvaibleMoreItems: boolean;
  onEndScrolling: () => void;
  isFetching: boolean;
}

const ItemsList: React.FC<IFilterItemListProps> = ({
  jsxListItems,
  isAvaibleMoreItems,
  onEndScrolling,
  isFetching,
  styles,
}) => {
  const { t } = useTranslation();
  return (
    <ListWithScrollEvent
      isFetching={isFetching}
      hasMoreItems={isAvaibleMoreItems}
      onEndScrolling={onEndScrolling}
      className={styles.body}
    >
      {!jsxListItems.length ? (
        <Typography variant="body2" className={styles.noFound}>
          {t(tPaths.table.notFound)}
        </Typography>
      ) : (
        jsxListItems
      )}
    </ListWithScrollEvent>
  );
};

function getScrolledPercentage(element: HTMLDivElement): number {
  const scrolledTop: number = element.scrollTop;

  const scrollableHeight: number = element.scrollHeight - element.clientHeight;

  return Math.floor((scrolledTop / scrollableHeight) * 100);
}

const BODY_LIST_ID = 'itemsList';

interface IListWithScrollEvent {
  children: React.ReactNode;
  onEndScrolling: () => void;
  hasMoreItems: boolean;
  isFetching: boolean;
  className: string;
}

const ListWithScrollEvent: React.FC<IListWithScrollEvent> = ({
  children,
  onEndScrolling,
  hasMoreItems,
  isFetching,
  className,
}) => {
  const listRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handler() {
      const scrolled = listRef.current ? getScrolledPercentage(listRef.current) : 0;

      if (scrolled > 98 && hasMoreItems && !isFetching) onEndScrolling();
    }

    if (listRef.current) listRef.current.addEventListener('scroll', handler);

    return () => {
      if (listRef.current) listRef.current.removeEventListener('scroll', handler);
    };
  }, [listRef.current, isFetching, onEndScrolling, hasMoreItems]);

  return (
    <div id={BODY_LIST_ID} ref={listRef} className={className}>
      {children}
    </div>
  );
};

export default ItemsList;
